<template>
  <v-app style="background: #eee" class="pa-3">
    <div >
      <span class="display-1 font-weight-light">Items On Sale</span>
      <v-divider class="mb-2"/>
      <v-layout row wrap>
        <span v-if="sellPostsOpen.length==0" class="subheading">You currently have no items on sale.</span>
        <v-flex xs12 sm6 md4 v-for="post in sellPostsOpen">
          <div class="mr-4 ml-4 mb-4">
            <SellCard
            :posted_by=post.data().posted_by
            :accepted=post.data().accepted
            :rejected=post.data().rejected
            :interested=post.data().interested
            :category=post.data().category
            :marked_price="Number(post.data().marked_price)"
            :item_name=post.data().item_name
            :photos=post.data().photos
            :postId=post.id
            />
          </div>
        </v-flex>
      </v-layout>
    </div>

    <div class="mt-5">
      <span class="display-1 font-weight-light">Sold Items</span>
      <v-divider class="mb-2"/>
      <v-layout row wrap>
        <span v-if="sellPostsClosed.length==0" class="subheading">You have no items sold.</span>
        <v-flex v-for="post in sellPostsClosed" xs12 sm6 md4>
          <div class="mr-4 ml-4">
            <ClosedSellcard
            :category=post.data().category
            :marked_price="Number(post.data().marked_price)"
            :item_name=post.data().item_name
            :photos=post.data().photos
            />
          </div>
        </v-flex>
      </v-layout>
    </div>
    <div v-if="dialog">
      <Popupsell
        :dialog="dialog"
        @hide="back"
        @success="onSuccess"
      ></Popupsell>
    </div>
      <v-snackbar
        v-model="snackbar"
        :color="color"
        :multi-line="mode === 'multi-line'"
        :timeout="timeout"
        :vertical="mode === 'vertical'"
      >{{ text }}</v-snackbar>
      <v-fab-transition>
        <v-btn color="amber" dark fab fixed bottom right large class="mb-4 mr-4" @click="create">
          <v-icon color="#35455c">add</v-icon>
        </v-btn>
      </v-fab-transition>
    </div>
  </v-app>
</template>

<script>
import firebase from "firebase";
import Popupsell from "@/components/Popupsell.vue";
import SellCard from "@/components/SellCard.vue";
import ClosedSellcard from "@/components/ClosedSellcard.vue";
export default {
  components: {
    Popupsell,
    ClosedSellcard,
    SellCard
  },
  data() {
    return {
      sellPosts: [],
      listener: null,
      snackbar: false,
      color: "",
      mode: "",
      timeout: 2000,
      text: "",
      dialog: false
    };
  },
  methods: {
    back() {
      this.dialog = false;
    },
    create() {
      this.dialog = true;
    },
    onSuccess() {
      var vm = this;
      vm.dialog = false;
      vm.color = "success";
      vm.text = "Post added successfully.";
      vm.snackbar = true;
    }
  },
  mounted() {
    const db = firebase.firestore();
    var vm = this;
    vm.listener = db
      .collection("posts_buy")
      .where("posted_by.uid", "==", firebase.auth().currentUser.uid)
      .orderBy("time_posted", "desc")
      .onSnapshot(function(snap) {
        vm.sellPosts = snap.docs;
      });
  },
  computed: {
    sellPostsOpen() {
      let open = [];
      var vm = this;
      for (var post of vm.sellPosts) {
        if (post.data().post_closed == false) {
          open.push(post);
        }
      }
      return open;
    },
    sellPostsClosed() {
      let closed = [];
      var vm = this;
      for (var post of vm.sellPosts) {
        if (post.data().post_closed == true) {
          closed.push(post);
        }
      }
      return closed;
    }
  },
  beforeDestroy() {
    this.listener();
  }
};
</script>
